import i18n from "../../i18n";
import React from "react";
import { Grid, Table, Text, Title } from "@mantine/core";

const SectionTable = ({ title, rows }) => (
  <>
    <Title order={6} mb="xs">
      {title}
    </Title>
    <Table striped withBorder mb="md">
      <thead>
        <tr>
          <th>{i18n.t("Code")}</th>
          <th>{i18n.t("Account")}</th>
          <th>{i18n.t("Amount")}</th>
        </tr>
      </thead>
      <tbody>
        {(rows || []).map((row) => (
          <tr key={row.code}>
            <td>{row.code}</td>
            <td>{row.name}</td>
            <td>{row.amount}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>
);

const CommissionAnalysisView = ({ report }) => {
  if (!report) return null;

  return (
    <Grid>
      <Grid.Col md={6}>
        <SectionTable title="Commission Income" rows={report.income} />
        <Text weight={600}>Total Income: {report.totalIncome}</Text>
      </Grid.Col>
      <Grid.Col md={6}>
        <SectionTable title="Commission Expense" rows={report.expense} />
        <Text weight={600}>Total Expense: {report.totalExpense}</Text>
      </Grid.Col>
      <Grid.Col span={12}>
        <Text weight={600} mt="md">
          Net Commission: {report.netCommission}
        </Text>
      </Grid.Col>
    </Grid>
  );
};

export default CommissionAnalysisView;
